export const mapEditorConfig = ({ cfg, canModifyUTM, isDev, isDemo }) => ({
  engagementTypeId: cfg.engagement.engagementTypeId,
  orderIndex:
    cfg.engagementMessage != null && cfg.engagementMessage.orderIndex != null ? cfg.engagementMessage.orderIndex : null,
  orderIndexes: cfg.orderIndexesAvailable != null ? cfg.orderIndexesAvailable : [],
  channelType: cfg.channelType ? cfg.channelType : null,
  optInTypeId: cfg.optInTypeId,
  engagementMessageId: cfg.engagementMessage != null ? cfg.engagementMessage.engagementMessageId : null,
  couponPoolId: cfg.engagementMessage != null ? cfg.engagementMessage.couponPoolId : null,
  engagementMessage: cfg.engagementMessage,
  engagementMessageCount: cfg.messageCount != null ? cfg.messageCount : 0,
  additionalMessageCount: cfg.additionalMessageCount != null ? cfg.additionalMessageCount : 0,
  engagementStatusId: cfg.engagement.engagementStatusId,
  engagement: cfg.engagement,
  isEmptyCampaign: false,
  isMultiLanguage: cfg.engagement.multiLanguage,
  engagementLanguages: cfg.engagementLanguages != null ? cfg.engagementLanguages : [],
  groups: cfg.groups || null,
  recommendationEventTypeId: cfg.recommendationEventTypeId || null,
  message: {
    subject: cfg.engagementMessage ? cfg.engagementMessage.subject : "",
    html: cfg.engagementMessage ? cfg.engagementMessage.messageBody : "",
    design: cfg.engagementMessage ? cfg.engagementMessage.editorLayout : "",
  },
  utm: {
    isUTMModificationAllowed: canModifyUTM,
    campaign: cfg.engagementMessage ? cfg.engagementMessage.utmCampaign : "",
    source: cfg.engagementMessage ? cfg.engagementMessage.utmSource : "",
    medium: cfg.engagementMessage ? cfg.engagementMessage.utmMedium : "",
    term: cfg.engagementMessage ? cfg.engagementMessage.utmTerm : "",
    areOverwritten: cfg.engagementMessage ? cfg.engagementMessage.areGaTagsOverwritten : false,
    urlToUpdate: "/engagements/updateGaTags",
  },
  sender: {
    avatarUrl: "https://d3vhsxl1pwzf0p.cloudfront.net/images/static/no_fb.jpg",
    name: cfg.engagement.fromName,
  },
  isDev,
  isDemo,
});
